import { Box, styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const Container = styled(Box)({
  flex: 1,
  marginLeft: '32px',
  overflow: 'auto',
});
